<template>
  <div></div>
</template>

<script>
export default
{
    async mounted()
    {
        await this.$router.replace('/main/overview/tasks');
    }
}
</script>